module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_8_after.jpg
// module id = 1171
// module chunks = 0